module.exports = __webpack_public_path__ + "img/fi-rr-paper-plane.30988ce1.svg";